import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// import * as swal from 'sweetalert';
import { UsuarioService } from '../../services/service.index';
import { Usuario, Usuario2 } from '../../models/usuario.model';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import swal2 from 'sweetalert2';

declare function init_plugins();

@Component({
  selector: 'app-crearusuario',
  templateUrl: './crearusuario.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class CrearUsuarioComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  forma: FormGroup;
  genero: any[];
  estatus: any[];

  constructor(
    public _usuarioService: UsuarioService,
    public router: Router
  ) { }

  sonIguales( campo1: string, campo2: string ) {

    return ( group: FormGroup ) => {

      let pass1 = group.controls[campo1].value;
      let pass2 = group.controls[campo2].value;

      if ( pass1 === pass2 ) {
        return null;
      }

      return {
        sonIguales: true
      };

    };

  }

  validar_email( email )
  {
      const regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email) ? true : false;
  }

  valida_password(pass) {
    const regex = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
    return regex.test( pass ) ? true : false;
  }

  ngOnInit() {

      this.forma = new FormGroup({
        nombre: new FormControl( null , Validators.required ),
        correo: new FormControl( null , [Validators.required, Validators.email] ),
        password: new FormControl( null , Validators.required ),
        password2: new FormControl( null , Validators.required ),
        puesto: new FormControl( null ),
        genero: new FormControl( 'MASCULINO' ),
        estatus: new FormControl( 'ACTIVO' ),
        multi_supplier: new FormControl("")

      }, { validators: this.sonIguales( 'password', 'password2' )  } );

      this._usuarioService.getUserGender().subscribe( resp => this.genero = resp );

      this._usuarioService.getUserStatus().subscribe( resp => this.estatus = resp );
  }


  registrarUsuario() {
    swal2.showLoading();
    if ( this.validar_email( this.forma.value.correo ) ) {
    // el correo es valido
    } else {
      Swal.fire(
        'Error al crear usuario',
        'El correo electronico no es valido',
        'error'
     );
      return null;
    }

    if ( this.valida_password( this.forma.value.password ) ) {
      // el correo es valido
      } else {
        Swal.fire(
          'Error al crear usuario',
          'La contraseña no tiene el formato correcto',
          'error'
       );
        return null;
      }

    if ( this.forma.value.password !== this.forma.value.password2 ) {

    Swal.fire(
      'Error al crear usuario',
      'Las contraseñas no son iguales',
      'error'
   );
    return null;
    }

    if ( this.forma.invalid ) {
      return;
    }

    const usuario = {
      'nombre': this.forma.value.nombre,
      'email': this.forma.value.correo,
      'password': this.forma.value.password,
      'puesto': this.forma.value.puesto,
      'genero': this.forma.value.genero,
      'estatus': this.forma.value.estatus,
      'multi_supplier': this.forma.value.multi_supplier
    };

    this._usuarioService.crearUsuario( usuario )
              .subscribe( resp => {
              swal2.close();
              Swal.fire({
                title: 'Creacion de usuario exitosa',
                text: '',
                icon: 'success',
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: false
              }). then ( res => {
                if ( res.value ) {
                  this.cerraroregusu();
                }
              } );
            }, (err) => {           swal2.close();
                                    console.log(err);
                                    Swal.fire(
                                        'Error al crear usuario',
                                        '',
                                        'error'
                                     );
                                  } );
  }

  cerraroregusu() {
    this.childEvent.emit({message: 'cerrarcreausr'})
  }

}
